import React,{useState} from  'react'
import { appNumber } from 'utils';

interface AppNumberRangeProps {
    format?:string
    min?:number
    max?:number
	onChange?: (min?:number,max?:number) => void
}

export const AppNumberRange = (props:AppNumberRangeProps) =>{

    const[min ,setMin] = useState(props.min||null)
    const[max, setMax] = useState(props.max||null)
    const[minActive, setMinActive] = useState(false)
    const[maxActive, setMaxActive] = useState(false)

    const hanldMinBlur = () =>{
        let text = appNumber.checkAndFormat(refMinInput.current.value) ;
        refMinInput.current.value = text;
        
        let newValue = appNumber.returnValue(text);
        if(newValue !== min){
            setMin(newValue)
            props.onChange && props.onChange(newValue,max)
        }
        setMinActive(false)
    }

    const hanldMaxBlur = () =>{
        let text = appNumber.checkAndFormat(refMaxInput.current.value) ;
        refMaxInput.current.value = text;
        
        let newValue = appNumber.returnValue(text);
        if(newValue !== min){
            setMax(newValue)
            props.onChange && props.onChange(min,newValue)
        }
        setMaxActive(false)
    }

    const handleAllChecked = () =>{
        if(min===null && max===null) return;
        if(refMinInput.current && refMaxInput.current) {
            refMinInput.current.value = '';
            refMaxInput.current.value = '';
        }
        props.onChange(null,null)
        setMin(null);
        setMax(null);
    }

    let allChecked = (min===null && max===null);

    const refMinInput = React.createRef<HTMLInputElement>()
    const refMaxInput = React.createRef<HTMLInputElement>()
    return ( 
    <div className='app-search-item-container'>
        <div className='app-search-item-left'>
            <div className='app-search-all-content'>
                <span className='app-all-option' 
					data-checked={allChecked} 
					onClick={handleAllChecked}>全部
					<i className="qcciconfont-select app-all-option-checked-icon" 
					hidden={!allChecked} />
				</span>
            </div>
        </div>
        <div className='app-search-item-right'>
            <div className='app-search-number-range-container'>
                <span>
                    <input ref={refMinInput} 
                        className='app-input-search' 
                        data-type='number'
                        defaultValue={appNumber.checkAndFormat(`${props.min}`)}
                        data-active ={minActive}  
                        onFocus={e => setMinActive(true)}
                        onBlur={hanldMinBlur}
                        style ={{width:160}}
                    />
                </span>
                <span className='span-split'>-</span>
                <span>
                    <input ref={refMaxInput} 
                        className='app-input-search' 
                        data-type='number'
                        defaultValue={appNumber.checkAndFormat(`${props.max}`)}
                        data-active ={maxActive}  
                        onFocus={e => setMaxActive(true)}
                        onBlur={hanldMaxBlur}
                        style ={{width:160}}
                    />
                </span>
               
            </div>
        </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppNumberRange.tsx